import { Phone } from 'lucide-react';
import { cn } from '../../../../shared';
import { COLORS } from './format';

/**
 * Candidate phone number as a tappable `tel:` chip, with a muted
 * "no phone on file" fallback. Two sizes: `md` for the scheduling card header
 * (calling is THE action there) and `sm` for the denser SLA cards.
 */
export function PhoneChip({ phone, size = 'md' }: { phone: string | null; size?: 'sm' | 'md' }) {
  const small = size === 'sm';
  if (!phone) {
    return (
      <span
        className={cn(
          'whitespace-nowrap rounded-full bg-gray-100 text-gray-400',
          small ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1.5 text-xs'
        )}
      >
        no phone on file
      </span>
    );
  }
  return (
    <a
      href={`tel:${phone}`}
      className={cn(
        'whitespace-nowrap rounded-full font-bold tracking-wide hover:opacity-80',
        small ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1.5 text-sm'
      )}
      style={{ backgroundColor: COLORS.blueBg, color: COLORS.blueText }}
    >
      <Phone className={cn('mr-1 inline shrink-0', small ? 'h-3 w-3' : 'h-3.5 w-3.5')} />
      {phone}
    </a>
  );
}
